import { Injectable } from '@angular/core';
import { Translation, TranslocoInterceptor } from '@jsverse/transloco';

function replaceLastOccurrence(value: string, search: string, replacement: string): string {
	const lastIndex = value.lastIndexOf(search);

	if (lastIndex === -1) {
		return value;
	}

	return `${value.slice(0, lastIndex)}${replacement}${value.slice(lastIndex + search.length)}`;
}

@Injectable()
export class BgovTranslocoInterceptor implements TranslocoInterceptor {
	private readonly warningTextsToHighlight = [
		'如果贵司不是方案供货商／初创企业，请选择“不适用 (N/A)”',
		'如果不是买家／企业访客，请选择“不适用 (N/A)”',
		'如果貴司不是方案供貨商／初創企業，請選擇“不適用 (N/A)”',
		'如果不是買家／企業訪客，請選擇“不適用 (N/A)”',
		'If your company is not a solution provider or a start\u2011up, please select \u2018Not Applicable (N/A)\u2019',
		'If you are not a buyer or corporate visitor, please select \u2018Not Applicable (N/A)\u2019',
		"Visitor's Rules & Regulations",
		'访客规则及法规',
		'訪客規則及法規'
	];

	preSaveTranslation(translation: Translation, locale: string): Translation {
		let updatedTranslation = translation;

		if ('country' in window && window.country === 'CN') {
			if ('fields.bgovBmBusinessObjectives.options.Taiwan Region' in translation) {
				const key = 'fields.bgovBmBusinessObjectives.options.Taiwan Region';

				if (locale === 'en') {
					updatedTranslation = {
						...updatedTranslation,
						[key]: 'Taiwan, China'
					};
				} else if (locale === 'zh-CN') {
					updatedTranslation = {
						...updatedTranslation,
						[key]: '中国台湾'
					};
				} else if (locale === 'zh-HK') {
					updatedTranslation = {
						...updatedTranslation,
						[key]: '中國台灣'
					};
				}
			}
		}

		for (const key of Object.keys(updatedTranslation)) {
			const value = updatedTranslation[key];

			if (typeof value === 'string') {
				for (const text of this.warningTextsToHighlight) {
					if (value.includes(text)) {
						updatedTranslation = {
							...updatedTranslation,
							[key]: replaceLastOccurrence(
								value,
								text,
								`<span class="red-text">${text}</span>`
							)
						};
						break;
					}
				}
			}
		}

		return updatedTranslation;
	}

	preSaveTranslationKey(_key: string, value: string, _lang: string): string {
		console.log(value);
		if (value.startsWith('AI+ Sales')) {
			return value.replace(/^AI\+\s*Sales/, 'AI+<br />Sales');
		}

		return value;
	}
}
